import { endlessPaginate } from "endless_pagination/endless-pagination-module.js";
import { MpBookmark } from "../../common/bookmark.js";
import { MultiGLightbox } from "../../common/image_gallery.js";
import { initRating } from "../../common/rating.js";
import { mbSocialSharing, socialSharing } from "../../common/sharing.js";
import { initAjaxLightbox, yieldToMainBackground } from "../../common/utils.js";
import { MpVideoPlayer } from "../../common/video_player.js";

function ready(fn) {
	if (document.readyState !== "loading") {
		fn();
	} else {
		document.addEventListener("DOMContentLoaded", fn);
	}
}

ready(() => {
	const multiJWP = new MpVideoPlayer();
	multiJWP.init().then((is_ready) => {
		// Lightbox gamecard galleria associata
		const gallery_data = document.querySelector("#_gallery-section");
		if (gallery_data) {
			const main_gallery = new MultiGLightbox({
				url: gallery_data.dataset.mainGalleryUrl,
				per_page: 20,
				selector: gallery_data.dataset.gallerySelector,
			});
		}

		// Pagina video e "da non perdere"
		if (document.querySelector("#_paginated_videos")) {
			document
				.querySelector("#_paginated_videos")
				.addEventListener("click", (event) => {
					const target = event.target;
					if (target?.classList.contains("_video_toggle")) {
						event.preventDefault();
						const current_video = target.nextElementSibling; // $(this).next('._show_video');
						if (!current_video.classList.contains("d-none")) {
							current_video.classList.add("d-none");
							const player_id =
								current_video.querySelector('[id^="video-"]').id;
							multiJWP.destroyPlayer(player_id);
						} else {
							fetch(`/video/video-player/${current_video.id}/`, {
								headers: {
									"X-Requested-With": "XMLHttpRequest",
								},
							})
								.then((response) => response.text())
								.then((data) => {
									current_video.innerHTML = data;
									const video_player =
										current_video.querySelector("._player-video");
									multiJWP.setupPlayer(
										video_player.id,
										video_player.dataset.video_uid,
										{
											is_youtube: video_player.dataset.is_youtube,
											noads: video_player.dataset.noads,
											article_url: video_player.dataset.video_article,
											is_downloadable: true,
										},
									);
									current_video.classList.remove("d-none");
								})
								.catch((error) => {
									console.warn(error);
								});
						}
					}
				});
		}

		// VIDEO SLOT
		if (document.querySelector("#_video_slot")) {
			for (const el of document.querySelectorAll(
				".video-grid__item:not(#_video_slot) a",
			)) {
				el.addEventListener("click", (event) => {
					event.preventDefault();
					const target = event.currentTarget;

					// remove current player
					multiJWP.destroyPlayer("_video_container");

					// load new player
					if (!!document.querySelector("#_video_container") === false) {
						const container = document.createElement("div");
						container.id = "_video_container";
						document
							.querySelector("#_video_slot .embed-responsive-item")
							.appendChild(container);
					}
					if (is_ready) {
						yieldToMainBackground().then(() => {
							multiJWP.setupPlayer(
								"_video_container",
								target.dataset.video_uid,
								{
									is_youtube: target.dataset.is_youtube,
									noads: target.dataset.no_ads,
									article_url: target.dataset.video_article,
									is_downloadable: true,
								},
							);
						});
					}

					// update data
					const video_div = document.querySelector("#_video_container");
					video_div.dataset.video_id = target.dataset.video_id;
					video_div.dataset.video_uid = target.dataset.video_uid;
					document
						.querySelector("#_video_slot")
						.querySelector("h2").textContent = target.dataset.name;
					for (const video of document.querySelectorAll(".video-grid__item")) {
						video.classList.remove("active");
					}
					target.parentNode.classList.add("active");
				});
			}
		}

		// SOCIAL SHARE
		if (document.querySelector("#social-share")) {
			const x_text = document.querySelector("#social-share .X").dataset.text;
			const fb = new socialSharing(
				document.querySelector("#social-share .facebook"),
				{ kind: "facebook" },
			);
			const x = new socialSharing(document.querySelector("#social-share .X"), {
				kind: "x",
				title: x_text,
				suffix: " via @Multiplayerit",
			});
			const tg = new socialSharing(
				document.querySelector("#social-share .telegram"),
				{ kind: "telegram" },
			);
			const wa = new socialSharing(
				document.querySelector("#social-share .whatsapp"),
				{ kind: "whatsapp" },
			);
		}
		const mb_share = document.querySelector("#_share-mb");
		if (mb_share) {
			mb_share.addEventListener("click", (event) => {
				event.preventDefault();
				mbSocialSharing(mb_share);
			});
		}

		// BOOKMARKS AND VOTE
		if (document.querySelector("#_gamecard_container")) {
			const gamecard_container = document.querySelector("#_gamecard_container");
			if (gamecard_container.dataset.ct && gamecard_container.dataset.id) {
				fetch(
					`/misc/bookmarks_and_vote/${gamecard_container.dataset.ct}/${gamecard_container.dataset.id}/`,
					{
						headers: {
							"X-Requested-With": "XMLHttpRequest",
						},
						cache: "no-cache",
					},
				)
					.then((response) => response.json())
					.then((data) => {
						const gamecard_bookmarks = data.gamecard_bookmarks;
						if (gamecard_bookmarks) {
							document.querySelector("#_gamecard_bookmarks").innerHTML =
								gamecard_bookmarks;
							init_gamecard_bookmarks();
						}
						const gamecard_rating_form = data.gamecard_rating_form;
						if (gamecard_rating_form) {
							document.querySelector("#_rating_form").innerHTML =
								gamecard_rating_form;
							initRating();
							initAjaxLightbox(
								document.querySelectorAll("._bookm_lightbox"),
								"modal-users",
							);
							initAjaxLightbox(
								document.querySelectorAll("._votes_lightbox"),
								"modal-users",
							);
						}
					})
					.catch((error) => {
						console.warn(error);
					});
			}
		}

		// Paginazione
		if (document.body.id === "game_card_videos") {
			endlessPaginate({
				moreSelector: "span.endless_more",
				moreSelectorDataUrl: "data-more",
				onCompleted: () => {
					// la classe _player-video viene eliminata da jwplayer quando istanzia il video
					const elements = document.querySelectorAll("._player-video");
					Array.prototype.forEach.call(elements, (el, i) => {
						if (is_ready) {
							yieldToMainBackground().then(() => {
								multiJWP.setupPlayer("_video_container", el.dataset.video_uid, {
									is_youtube: el.dataset.is_youtube,
									noads: el.dataset.no_ads,
									article_url: el.dataset.video_article,
									is_downloadable: true,
								});
							});
						}
					});
				},
			});
		} else {
			endlessPaginate({
				moreSelector: "span.endless_more",
				moreSelectorDataUrl: "data-more",
			});
		}
	});
});

function init_gamecard_bookmarks() {
	const game_follow = new MpBookmark(
		document.querySelector("#_gamecard_follow span:not(.bookmarks_counter)"),
		{
			message: document.querySelector("#_gamecard_follow .tab_label"),
			message_on: "Non seguire",
			message_off: "Segui",
			form: document.querySelector("#_gamecard_follow .bookmarks_form"),
			counter: document.querySelector("#_gamecard_follow .bookmarks_counter a"),
		},
	);
}
